<template>
  <UsersView
    :id="profile.id"
    :view-type="viewType"
  />
</template>

<script>
import * as TYPES from '@/helpers/enums/view-types'
import { authStoreMapper } from '@/views/Auth/store'
import { SAVE_MENUS } from '@/components/common/BFormButtons.vue'
import { usersMapper } from './store'
import { UserModel as Model } from './Model'

import UsersViewOrigin from './UsersView.vue'


const UsersView = {
  extends: UsersViewOrigin,
  data() {
    return {
      backRoute: void 0,
      isProfile: true,
      saveMenuList: [
        SAVE_MENUS.SAVE,
      ],
    }
  },
  computed: {
    createRoute() {
      return null
    },
    editRoute() {
      return null
    },
    pageTitle() {
      return Model.page_title.profile
    },
    update() {
      return this.updateProfile
    },
    deletable() {
      return false
    },
  },
  methods: {
    ...authStoreMapper.mapActions({ updateProfileAuth: 'update' }),
    ...authStoreMapper.mapActions(['getProfile']),

    async updateProfile(...args) {
      const result = await this.storeModule.actions.update(...args)
      await this.getProfile()
      return result
    },
    toSaveGoCommon() {
      // отключим переход к users.edit роуту
    },
  },
}

export default {
  name: 'ViewUsersProfile',
  components: {
    UsersView,
  },
  computed: {
    ...authStoreMapper.mapState(['profile']),
    ...usersMapper.mapState(['single']),

    viewType() {
      const { single } = this
      if (single?.id !== this.profile.id) return TYPES.VIEW
      const actions = single.actions || []
      return actions.includes('edit') ? TYPES.EDIT : TYPES.VIEW
    },
  },
}
</script>
